import React, { createContext, useContext, useRef, useMemo } from 'react';
import { saveFile, getFile } from '../services/storage';

const EditorContext = createContext(null);

export function EditorProvider({ children, domain, accessToken, dbRef }) {
  const iframeRef = useRef(null);
  const editorRef = useRef(null);

  const value = useMemo(() => ({
    // Config
    domain,
    accessToken,

    // Refs
    dbRef,
    iframeRef,
    editorRef,

    // Storage helpers (direct access)
    saveFile,
    getFile
  }), [domain, accessToken, dbRef]);

  return (
    <EditorContext.Provider value={value}>
      {children}
    </EditorContext.Provider>
  );
}

export function useEditor() {
  const context = useContext(EditorContext);
  if (!context) {
    throw new Error('useEditor must be used within EditorProvider');
  }
  return context;
}

export default EditorContext;
